import { ReloadIcon } from '@radix-ui/react-icons'
import { IconProps } from '@radix-ui/react-icons/dist/types'
import clsx from 'clsx'
import React from 'react'

import { formatLengthValue } from '@/utils/css'

import styles from './OldSpinner.module.scss'

interface SpinnerProps extends IconProps, React.RefAttributes<SVGSVGElement> {
  width?: string | number
  height?: string | number
  className?: string
}

const OldSpinner: React.FC<SpinnerProps> = ({
  className,
  width = 16,
  height = 16,
  ...restProps
}) => (
  <ReloadIcon
    data-testid="loading-spinner"
    className={clsx(className, styles.spinner)}
    width={formatLengthValue(width)}
    height={formatLengthValue(height)}
    {...restProps}
  />
)

export default OldSpinner
